import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { PaymentInstallmentEntity } from '../../../../../../../api/types/payments/installments/entities';

interface CancelInstallmentWarningDialogProps {
  visible: boolean;
  onHide: () => void;
  installment: PaymentInstallmentEntity | null;
  onConfirm: (shouldSplitRemainder: boolean) => Promise<void>;
  loading: boolean;
}

export const CancelInstallmentWarningDialog: React.FC<
  CancelInstallmentWarningDialogProps
> = ({ visible, onHide, installment, onConfirm, loading }) => {
  const [shouldSplitRemainder, setShouldSplitRemainder] = useState(true);

  const handleConfirm = async () => {
    await onConfirm(shouldSplitRemainder);
  };

  const handleHide = () => {
    setShouldSplitRemainder(true); // Reset to default when closing
    onHide();
  };

  return (
    <Dialog
      header="ביטול תשלום"
      visible={visible}
      onHide={handleHide}
      style={{ width: '500px' }}
      footer={
        <div
          style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}
        >
          <Button
            label="ביטול"
            icon="pi pi-times"
            severity="secondary"
            onClick={handleHide}
            disabled={loading}
          />
          <Button
            label="אישור ביטול"
            icon="pi pi-check"
            severity="danger"
            onClick={handleConfirm}
            loading={loading}
          />
        </div>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '16px',
            backgroundColor: '#FEF3C7',
            borderRadius: '8px',
            border: '1px solid #F59E0B',
          }}
        >
          <i
            className="pi pi-exclamation-triangle"
            style={{ fontSize: '24px', color: '#F59E0B' }}
          />
          <div>
            <div style={{ fontWeight: 'bold', color: '#92400E' }}>
              האם אתה בטוח שברצונך לבטל תשלום זה?
            </div>
            {installment && (
              <div style={{ color: '#92400E', marginTop: '4px' }}>
                תשלום מספר {installment.installmentNumber} בסכום ₪
                {installment.amount?.toLocaleString()}
              </div>
            )}
          </div>
        </div>

        <div
          style={{
            padding: '16px',
            backgroundColor: '#F3F4F6',
            borderRadius: '8px',
          }}
        >
          <div
            style={{
              fontWeight: 'bold',
              marginBottom: '12px',
              color: '#374151',
            }}
          >
            מה לעשות עם הסכום שלא ישולם?
          </div>

          <div
            style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '12px',
                padding: '12px',
                backgroundColor: shouldSplitRemainder ? '#DBEAFE' : 'white',
                borderRadius: '8px',
                border: `2px solid ${shouldSplitRemainder ? '#3B82F6' : '#E5E7EB'}`,
                cursor: 'pointer',
              }}
              onClick={() => setShouldSplitRemainder(true)}
            >
              <Checkbox
                checked={shouldSplitRemainder}
                onChange={() => setShouldSplitRemainder(true)}
              />
              <div>
                <div style={{ fontWeight: 'bold', color: '#1F2937' }}>
                  פיצול לתשלומים הנותרים
                </div>
                <div
                  style={{
                    fontSize: '14px',
                    color: '#6B7280',
                    marginTop: '4px',
                  }}
                >
                  סכום התשלום המבוטל יתחלק באופן שווה בין התשלומים הממתינים
                  הנותרים
                </div>
              </div>
            </div>

            <div
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '12px',
                padding: '12px',
                backgroundColor: !shouldSplitRemainder ? '#FEE2E2' : 'white',
                borderRadius: '8px',
                border: `2px solid ${!shouldSplitRemainder ? '#EF4444' : '#E5E7EB'}`,
                cursor: 'pointer',
              }}
              onClick={() => setShouldSplitRemainder(false)}
            >
              <Checkbox
                checked={!shouldSplitRemainder}
                onChange={() => setShouldSplitRemainder(false)}
              />
              <div>
                <div style={{ fontWeight: 'bold', color: '#1F2937' }}>
                  הפחתה מהסכום הכולל
                </div>
                <div
                  style={{
                    fontSize: '14px',
                    color: '#6B7280',
                    marginTop: '4px',
                  }}
                >
                  סכום התשלום המבוטל יופחת מהסכום הכולל של הוראת הקבע
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            padding: '12px',
            backgroundColor: '#FEF2F2',
            borderRadius: '8px',
            border: '1px solid #FECACA',
            fontSize: '14px',
            color: '#991B1B',
          }}
        >
          <i className="pi pi-info-circle" style={{ marginLeft: '8px' }} />
          פעולה זו אינה ניתנת לביטול לאחר ביצוע.
        </div>
      </div>
    </Dialog>
  );
};
